import { createReducer, on } from '@ngrx/store';
import { ProductDetail } from '../../../models/product-detail';
import { loadProduct, loadProductFail, loadProductSuccess, loadPublicProductByAssetTag, loadPublicProductByAssetTagFail, resetProduct } from './product.actions';

export interface ProductState {
    productDetail?: ProductDetail[];
    customerId?: string;
    contractId?: string;
    documentValue?: string;
    orgType?: string;
    orgId?: string;
    loading: boolean;
    error: { token: string; message?: string } | null;
}

export const initialState: ProductState = {
    documentValue: undefined,
    loading: false,
    error: null
};

export const productRecuder = createReducer(
    initialState,
    on(loadProductSuccess, (state, { productDetail, documentValue, customerId, contractId, orgType, orgId }) => {
        const updates: Partial<ProductState> = { productDetail, loading: false, error: null };
        if (documentValue !== undefined) updates.documentValue = documentValue;
        if (customerId !== undefined) updates.customerId = customerId;
        if (contractId !== undefined) updates.contractId = contractId;
        if (orgType !== undefined) updates.orgType = orgType;
        if (orgId !== undefined) updates.orgId = orgId;
        return { ...state, ...updates };
    }),
    on(loadProduct, (state, { customerId, contractId, documentValue, orgType, orgId }) => {
        const updates: Partial<ProductState> = { ...state, productDetail: undefined, customerId, contractId, documentValue, loading: true, error: null };
        if (orgType !== undefined) updates.orgType = orgType;
        if (orgId !== undefined) updates.orgId = orgId;
        return updates as ProductState;
    }),
    on(loadPublicProductByAssetTag, state => {
        return { ...state, productDetail: undefined, loading: true, error: null };
    }),
    on(loadProductFail, state => {
        return { ...state, loading: false };
    }),
    on(loadPublicProductByAssetTagFail, (state, { error }) => {
        return { ...state, loading: false, error };
    }),
    on(resetProduct, state => {
        return { ...state, productDetail: undefined, customerId: undefined, contractId: undefined, documentValue: undefined, orgType: undefined, orgId: undefined, loading: false, error: null };
    })
);
